import { FlexContainer, Icon, IconName, Label } from '@facephi/ui-react';
import { useTranslation } from 'react-i18next';
import { StyledDetailError } from './Styles';
import {
  ErrorLiteralType,
  OperationReasonsTexts,
  OperationResultReasonTypes,
  ignoredValidations,
} from '../../../state/model/operations';

const getIcon = (message: string): IconName => {
  if (message.includes(OperationResultReasonTypes.timeout)) {
    return 'HourglassLow';
  } else if (message.includes(OperationResultReasonTypes.cancelByUser)) {
    return 'XCircle';
  } else if (message.includes(OperationResultReasonTypes.notPassed)) {
    return 'UserSquare';
  } else if (message.includes(OperationResultReasonTypes.alreadyRegistered)) {
    return 'SmileySad';
  } else if (message.includes(OperationResultReasonTypes.expiredByScheduler)) {
    return 'CalendarX';
  } else if (message.includes(OperationResultReasonTypes.manualStatusChange)) {
    return 'ArrowsLeftRight';
  } else {
    return 'Warning';
  }
};

const getTexts = (error: string): ErrorLiteralType =>
  OperationReasonsTexts[error] ?? error;

export const DetailError = ({
  error,
  decision,
  mode,
}: {
  error: string;
  decision?: string;
  mode?: string;
}) => {
  const { t } = useTranslation();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { title, description } = getTexts(error) || {};
  return (
    <StyledDetailError columnGap="0.8">
      <Icon
        iconName={getIcon(error)}
        size="24"
        color="error400"
        weight="light"
      />
      <FlexContainer rowGap="0.8" flexDirection="column">
        <Label fontSize="14" semibold color="error400">
          {`${t(title || error)} ${
            mode && ignoredValidations.includes(mode) ? `(${mode})` : ''
          }`}
        </Label>
      </FlexContainer>
    </StyledDetailError>
  );
};
